import { useToast } from '@/components/common/toast';
import type { EmailRecipientGroupSettingDto } from '@/api/types/emailRecipients';
import { useSetGroupMode } from './api';

interface GroupSettingsCardProps {
  settings: EmailRecipientGroupSettingDto[];
  canUpdate: boolean;
}

// Mirrors the legacy "Recipient Group Settings" card: a suppress ("send to
// nobody") switch per group.
export function GroupSettingsCard({ settings, canUpdate }: GroupSettingsCardProps) {
  const toast = useToast();
  const setMode = useSetGroupMode();

  function onToggle(group: EmailRecipientGroupSettingDto, next: boolean) {
    setMode.mutate(
      { group: group.group, isSuppressed: next },
      {
        onSuccess: () => toast.success('Saved.'),
        onError: () => toast.error('Failed to update the group setting.'),
      },
    );
  }

  return (
    <div className="card mb-3">
      <div className="card-header border-0">
        <h5 className="card-title mb-0">Group Settings</h5>
      </div>
      <div className="card-body">
        <p className="text-muted">
          When enabled, no email is sent for that group even if recipients are listed below.
        </p>
        <div className="row g-3">
          {settings.map((s) => (
            <div key={s.group} className="col-12 col-sm-6 col-lg-3">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id={`suppress-${s.group}`}
                  checked={s.isSuppressed}
                  disabled={!canUpdate || setMode.isPending}
                  onChange={(e) => onToggle(s, e.target.checked)}
                />
                <label className="form-check-label" htmlFor={`suppress-${s.group}`}>
                  {s.groupName} — Send to nobody
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
